import lowerCase from 'lodash/lowerCase';
import momentTimeZone from 'moment-timezone';
import { toast } from 'react-toastify';
import { logoutAction, removeAPIDataAction } from '../../Store/callAPI/actions';
import { addLinkParamsToStore, resetCommonStoreToStore } from '../../Store/commonStore/actions';
import { DataKey } from '../../Store/callAPI/allAPIs';
import { Store } from '../../Store/Store';
import { referralStatisRejected, referralStatisSuspended, stepLanguageCodes, TimeZones } from '../constants/CommonConstants';

// Get the data from the common json file
export const getCommonJsonIdData = (id) => {
    const store = Store.getState();
    const data = store?.APIData?.GetCommonListAPI?.[DataKey]?.[id];
    return data || null;
};

export const convertUTCtoSpecificTimezone = (utcDate, timeZone, formate) => {
    const findZone = getCommonJsonIdData(TimeZones)?.find((zone) => {
        return zone.TZ === timeZone;
    });

    const localDate = momentTimeZone
        .tz(utcDate?.includes('Z') ? utcDate : utcDate + 'Z', findZone?.TZVALUE)
        .format(formate || 'MM/DD/YYYY');
    return localDate;
};

export const isReferralSuspendedOrRejected = (referralStatus) => {
    return (
        lowerCase(referralStatus) === lowerCase(referralStatisSuspended) || lowerCase(referralStatus) === lowerCase(referralStatisRejected)
    );
};

export const formatPhoneNumber = (value) => {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    const phoneNumber = value?.replace(/[^\d]/g, '');

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber?.length;

    /*
     * we need to return the value with no formatting if its less then four digits
     * this is to avoid weird behavior that occurs if you  format the area code to early
     */
    if (phoneNumberLength < 4) return phoneNumber;

    /*
     * if phoneNumberLength is greater than 4 and less the 7 we start to return
     * the formatted number
     */
    if (phoneNumberLength < 7) {
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }

    /*
     * finally, if the phoneNumberLength is greater then seven, we add the last
     * bit of formatting and return it.
     */
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};
// write a function to cut text into 200 characters
export const cutTextInto200characters = (str) => {
    if (str?.length > 250) {
        return str?.substring(0, 250);
    } else {
        return str;
    }
};
export const saveByteArray = (byte, name, viewOrDownMode = 'view') => {
    let fileType = 'application/pdf'; // Default type
    const extension = name?.split('.').pop()?.toLowerCase();
    // Determine MIME type based on extension
    if (extension === 'jpg' || extension === 'jpeg') {
        fileType = 'image/jpeg';
    } else if (extension === 'png') {
        fileType = 'image/png';
    } else if (extension === 'doc' || extension === 'docx') {
        fileType = 'application/msword';
    } else if (extension === 'xls' || extension === 'xlsx') {
        fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (extension === 'ppt' || extension === 'pptx') {
        fileType = 'application/vnd.ms-powerpoint';
    } else if (extension === 'pdf') {
        fileType = 'application/pdf';
    }

    var blob = new Blob([byte], { type: fileType });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = name;
    link.download = fileName;
    viewOrDownMode === 'view' ? window.open(link, '_blank') : link.click();
    toast.dismiss();
};

export const base64ToArrayBuffer = (base64) => {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
};
export const handleViewFileFromInputSource = (file) => {
    if (file) {
        const fileUrl = URL.createObjectURL(file);
        const newWindow = window.open();
        if (file.type === 'application/pdf') {
            newWindow.document.write(
                `<iframe src="${fileUrl}#toolbar=0" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>`
            );
        } else if (file.type.startsWith('image/')) {
            newWindow.document.write(
                `<html><body style="margin:0; display:flex; justify-content:center; align-items:center; height:100vh; background-color:#f0f0f0;">
                        <img src="${fileUrl}" style="max-width:100%; max-height:100%;" oncontextmenu="return false;" />
                    </body></html>`
            );
        } else {
            newWindow.document.write(
                `<html><body style="margin:0; display:flex; justify-content:center; align-items:center; height:100vh; font-family:sans-serif;">
                        <div style="text-align:center;">
                            <h3>Preview not available</h3>
                            <p>This file type cannot be previewed in the browser.</p>
                        </div>
                    </body></html>`
            );
        }
    }
};

export const handleLogout = (linkParams, navigate) => {
    const { environment, lang, xpLang, uniquelink, uniquekey, tenant } = linkParams;

    const language = lang || xpLang || 'en';
    let path = '';
    if (environment === 'xp') {
        path = `/authorize/xp/${language}/${uniquelink}/${uniquekey}`;
    } else {
        path = `/authorize/${uniquelink}`;
    }
    const tenantPrefix = tenant && tenant !== 'ggh' ? `/${tenant}` : '';
    const finalPath = `${tenantPrefix}${path}`;
    addLinkParamsToStore({
        ...linkParams,
        apiKey: null,
        token: null,
        referralId: null,
        roleid: null,
        userid: null
    });
    removeAPIDataAction('MemberInfoAPI');
    removeAPIDataAction('AuthenticationAPI');
    removeAPIDataAction('GetRolePermissionsAPI');
    navigate(finalPath);
};

export const displayStepsBasedOnLanguage = () => {
    const store = Store.getState();
    const stepLanguageCodesList = getCommonJsonIdData(stepLanguageCodes) || [];
    const selectedStepsLanguage = store?.CommonStore?.selectedLanguage;
    if (!stepLanguageCodesList || stepLanguageCodesList?.length === 0) {
        return true;
    }

    return stepLanguageCodesList?.includes(selectedStepsLanguage?.value);
};
